import React from "react";
import { connect } from "react-redux";
import "./PracticeCard.scss";
import ProgressBar from "../../../../../../custom_utilities/ProgressBar/ProgressBar";
import images from "../../../../../../utilities/images/images";
import { useHistory } from "react-router-dom";

const PracticeCard = ({ chap, userData, web_load_url }) => {
  const {
    chapter_name,
    chapter_icon,
    total_qn_blanks,
    progress_percent,
    allowed_actions,
    class_name,
    chapter_id,
    is_locked,
    buy_package_id,
  } = chap;

  const hasStart = allowed_actions?.includes("start");
  const hasResetStart = allowed_actions?.includes("reset_start");
  const hasResume = allowed_actions?.includes("resume");
  const isReadMode = allowed_actions?.includes("read_mode");
  const isCompleted = progress_percent === 100;
  const isPending = progress_percent > 0 && progress_percent < 100;
  const isLocked = Number(is_locked) === 1;
  const history = useHistory();

 
const handleAction = (actionType) => {
  history.push("/ncert-test", {
    chapter_id,
    action: actionType,
  });
};

  const getStatusBadge = () => {
    if (isCompleted) {
      return "Completed";
    } else if (isPending) {
      return "Pending";
    }
    return null;
  };

  const handleNavigate = () => {
    if (buy_package_id) {
      history.push(`/package/${buy_package_id}`);
    }
  };

  return (
    <div className="practice-card">
      <div className="practice-card__header">
        <div className="practice-card__header-left">
          <div className="practice-card__header-left__class">
            Class {class_name}
          </div>

          {(isCompleted || isPending) && (
            <div
              className={`practice-card__header-left__status ${getStatusBadge()}`}
            >
              {getStatusBadge()}
            </div>
          )}
        </div>

        <div
          className="practice-card__header-right"
          style={{ cursor: isLocked ? "not-allowed" : "pointer" }}
        >
          {!isLocked && isReadMode && (
            <img
              src={images.readMode}
              alt="readmode"
              onClick={() => handleAction("read_mode")}
            />
          )}
        </div>
      </div>

      <div className="practice-card__details">
        <img src={chapter_icon} alt="icon" />

        <div className="practice-card__details-info">
          <div className="practice-card__details-info__title">
            {chapter_name}
          </div>
          <div className="practice-card__details-info__questions">
            {total_qn_blanks} Questions
          </div>
        </div>
      </div>

      <div className="practice-card__progressbar">
        <div></div>
        <ProgressBar
          progress={progress_percent}
          height="12px"
          color="#079455"
        />
      </div>

      <div className="practice-card__buttons">
        {isLocked ? (
          <button
            className="practice-card__buttons-locked"
            id="locked-button"
            onClick={handleNavigate}
            disabled={!buy_package_id}
            style={{ cursor: buy_package_id ? "pointer" : "not-allowed" }}
          >
            Locked
            <img
              src={images.LockedIcon}
              alt="locked icon"
              style={{ width: "18px", height: "18px" }}
            />
          </button>
        ) : hasStart ? (
          <button
            className="practice-card__buttons-start"
            onClick={() => handleAction("start")}
          >
            Start Practice
          </button>
        ) : (
          <div className="practice-card__buttons-flex">
            {hasResetStart && (
              <button
                className="practice-card__buttons-flex-reset-start"
                onClick={() => handleAction("reset_start")}
              >
                Reset & Start
              </button>
            )}

            {hasResume && (
              <button
                className="practice-card__buttons-flex-resume"
                onClick={() => handleAction("resume")}
              >
                Resume
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.auth.user,
  };
};

export default connect(mapStateToProps)(PracticeCard);
